/**
 * 防抖 <button v-debounce>submit</button 按钮防抖自定义指令debounce.js
 */
export default {
  inserted(el, binding) {
    let throttleTime = binding.value; // 防抖时间
    if (!throttleTime) { // 用户若不设置防抖时间，则默认1s
      throttleTime = 2000;
    }
    let cbFun;
    el.addEventListener('click', event => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  },
}





// WEBPACK FOOTER //
// ./src/directive/debounce/debounce.js